var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.8188 2.41615e-06L11.4005 2.41828L21.0736 12.0914L1.70057e-06 12.0914L1.09653e-06 15.5461L21.0736 15.5461L11.4005 25.2192L13.8187 27.6375L27.6375 13.8188L13.8188 2.41615e-06Z","fill":"#83EABF"}));
}

Arrow.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
